module.exports = __webpack_public_path__ + "img/article_8_2.16495814.png";